import '@fontsource/cormorant-garamond/latin-400.css';
import '@fontsource/cormorant-garamond/latin-500.css';
import '@fontsource/cormorant-garamond/latin-600.css';
import '@fontsource/cormorant-garamond/latin-700.css';
import '@fontsource/cormorant-garamond/latin-400-italic.css';
import '@fontsource/cormorant-garamond/latin-500-italic.css';
import '@fontsource/playfair-display/latin-400.css';
import '@fontsource/playfair-display/latin-500.css';
import '@fontsource/playfair-display/latin-600.css';
import '@fontsource/playfair-display/latin-700.css';
import '@fontsource/jost/latin-300.css';
import '@fontsource/jost/latin-400.css';
import '@fontsource/jost/latin-500.css';
import '@fontsource/jost/latin-600.css';
import '@fontsource/jost/latin-700.css';
import '@fontsource/work-sans/latin-400.css';
import '@fontsource/work-sans/latin-500.css';
import '@fontsource/work-sans/latin-600.css';
import '@fontsource/work-sans/latin-700.css';

export const fonts = [
  { name: 'Cormorant Garamond', family: "'Cormorant Garamond', serif", label: 'Élégante & classique' },
  { name: 'Playfair Display', family: "'Playfair Display', serif", label: 'Éditoriale & affirmée' },
  { name: 'Jost', family: "'Jost', sans-serif", label: 'Sobre & contemporaine' },
  { name: 'Work Sans', family: "'Work Sans', sans-serif", label: 'Claire & chaleureuse' },
];
export const fontFamily = name => fonts.find(f => f.name === name)?.family || fonts[2].family;